import React from 'react'
import { TriggerPipelineOnCallback, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import PropTypes from 'prop-types'
import { CallbackOnPipe, Pipeline } from '@morningtrain/react-pipelines'
import { CloseModalOnPipe, OpenModalOnPipe } from '@morningtrain/react-resources'

function OpenModalOnClick ({
  modal,
  children,
  onClosePipes = null,
}) {

  const modalRef = React.useRef()

  const _resolve = React.useRef()
  const _reject = React.useRef()

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      _resolve.current = data => {
        payload.data = data
        resolve(data)
      }
      _reject.current = (err) => {
        reject(err)
      }
    })
  }

  const handleClose = (err) => {
    if (_reject.current !== null) {
      _reject.current(err)
    }

    if (callbackRef.current && typeof callbackRef.current === 'function') {
      callbackRef.current()
    }
  }

  const callbackRef = React.useRef(null)

  const updateCallbackRef = (callback) => {
    callbackRef.current = callback
  }

  return (
    <>
      {React.cloneElement(
        modal,
        { ref: modalRef, handleClose: handleClose, ...modal.props }
      )}
      <Pipeline>
        <OpenModalOnPipe modalRef={modalRef}/>
        <CallbackOnPipe callback={handleOnPipe}/>
        <CloseModalOnPipe modalRef={modalRef}/>
        <TriggerPipelineOnClick>
          {children}
        </TriggerPipelineOnClick>
      </Pipeline>
      <Pipeline>
        <TriggerPipelineOnCallback callback={updateCallbackRef}/>
        {onClosePipes}
      </Pipeline>
    </>
  )
}

OpenModalOnClick.propTypes = {
  modal: PropTypes.node,
  children: PropTypes.node,
}

export default OpenModalOnClick
